import React, {Component} from 'react';

import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Link from '@material-ui/core/Link';
import papersmaurice from './PaperList.json';







const classes = {
  paper: {
    width: '90%',
    marginLeft: '5%',
    marginRight: '5%',
    marginTop: 70,
    marginBottom: '5%', 
    fontFamily: 'Optima',
    color: '#6a737b',
    borderLeft: '0.03em solid grey',
    padding: '3%',
    backgroundColor: '#E6EBE9',
    //maxHeight: '60vh',
    //overflow: 'scroll',
    padding:'5%'
  },
  p :{
    color: '#333333' ,
    paddingLeft: '0%',
    paddingTop: '3%',
    paddingBottom: '3%',
    paddingRight: '5%',
    margin:0} 
};


const GenListItem=(item) =>{ 
  return(
  <ExpansionPanel  key={item.title} className={classes.root}>
    <ExpansionPanelSummary
      expandIcon={<ExpandMoreIcon />}
      style={{ backgroundColor : '#C1E5DD'}}
    >
        <Typography> 
           <span style={{ fontStyle:'italic', fontSize : '16px', color: '#333333'   }}> {item.title} <br/></span> 
           <span style={{ fontSize : '13px', color: '#333333'   }} > {item.authors} <br/> {item.journal} </span>
        </Typography>
    </ExpansionPanelSummary>
  
    <ExpansionPanelDetails style={{backgroundColor :'#E6EBE9'}}>
      <Typography style ={{marginLeft : '6%', width : '88%',  fontSize : '14px', color: '#333333'}}>
        Abstract:   <br/><br/> {item.abstract} 
        <br/> <Link href={item.arXiv}>arXiv</Link>          
      </Typography>
    </ExpansionPanelDetails>
  </ExpansionPanel>
);
  ;}



export class Papers extends Component {
  constructor(props){ 
    super(props);
    this.state={
      list:papersmaurice.list}; /* replace with list:[]/*
 
     

    /* fetch('./PaperList.json')
      .then(response => response.json())
      .then(data => {
        this.setState({list :data.list})
      }); */
  }

 
  render(){
  
  return(
    <div style={classes.paper}>
      <Typography style={{color:'#009688'}} variant="h4" >
          Research Papers
      </Typography>
      
      <Typography  align="left" style={classes.p}> 
          Below is a list of my research papers. Click on a paper to get its abstract and a link to the arXiv. 
      </Typography>
     
      {this.state.list.map(item=> GenListItem(item))}
   
    </div>);
    
    
    
  
}
}

export default Papers;